module.exports = __webpack_public_path__ + "img/747@2x.2f4a1b16.png";